export default __webpack_public_path__ + "static/media/property_690.5c320505.png";